import DB from '@/stores/db'
import { openDB } from 'idb'
import { v4 as uuidv4 } from 'uuid'
import { DateTime } from 'luxon'
import { useUserStore } from '@/stores/userStore'
import { useImageStore } from '@/stores/imageStore'
import { useTrainingCourseStore } from '@/stores/trainingCourseStore'
import AppConfig from '~/config/appConfig.js'

export default class ImageDb {
  static storeName = 'images'

  static clear() {
    DB.clear(this.storeName)
  }

  static remove(uuid) {
    // remove image , left to determine whether neccessary
  }

  static add(data_url) {
    const uuid = uuidv4()
    DB.add(this.storeName, { uuid: uuid, data_url: data_url, uploadaed: false })
    return uuid
  }

  static async addUrlFromServer(url) {
    const uuid = uuidv4()
    const requestOptions = {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache'
      // referrerPolicy: 'no-referrer'
    }
    let blob = await fetch(url, requestOptions).then((r) => r.blob())
    const reader = new FileReader()
    reader.addEventListener(
      'load',
      () => {
        const data_url = reader.result
        DB.add(this.storeName, { uuid: uuid, data_url: data_url, uploadaed: true })
      },
      false
    )
    reader.readAsDataURL(blob)
    return uuid
    // const uuid = uuidv4()
    // const requestOptions = {
    //   method: 'GET',
    //   mode: 'cors',
    //   cache: 'no-cache',
    //   referrerPolicy: 'no-referrer'
    // }
    // let data_url = await fetch(url, requestOptions).then((r) => r.blob())

    // DB.add(this.storeName, { uuid: uuid, data_url: data_url, uploadaed: true })
    // return uuid
  }

  static async url(uuid) {
    const image = await DB.fromKey(this.storeName, uuid)
    // return URL.createObjectURL(image.data_url)
    return image?.data_url
  }
  static async upload(data) {
    const entity_type = data.entity_type
    const imageStore = useImageStore()
  
    if (entity_type === 'customer') {
      imageStore.addImage({
        type: 'customer',
        entity_type: data.entity_type,
        type_id: data.type_uuid,
        uuid: data.uuid
      })
    } else if (entity_type === 'field') {
      imageStore.addImage({
        type: 'field',
        type_id: data.type_uuid,
        uuid: data.uuid
      })
    } else if (entity_type === 'trainingCourse') {
      imageStore.addImage({
        type: 'trainingCourse',
        type_id: data.type_uuid,
        uuid: data.uuid
      })
    } else if (entity_type === 'assessment') {
      imageStore.addImage({
        type: 'assessment',
        type_id: data.type_uuid,
        uuid: data.uuid
      })
    } else if (entity_type === 'ninCardFront') {
      imageStore.addImage({
        type: data.type,
        entity_type: data.entity_type,
        type_id: data.type_uuid,
        uuid: data.uuid,
        customer_uuid: data.customerUuid // Include customer UUID
      });
    } else if (entity_type === 'agriSubContract') {
      imageStore.addImage({
        entity_type: 'agriSubContract',
        type_id: data.type_uuid,
        uuid: data.uuid,
        type: data.type,
      })
    }

    const onFileUpload = async (res) => {
      if(data.entity_type === 'trainingCourse') {
        const trainingCourseStore = useTrainingCourseStore()
        const documentsLength = trainingCourseStore.find(data.type_uuid)?.documents?.length || 0
        for(let i = 0; i < 5; i++) {
          const course = await trainingCourseStore.reloadDocuments(data.type_uuid)
          if(course.documents?.length > documentsLength) {
            break;
          } else {
            await new Promise((resolve) => setTimeout(resolve, 6000))
          }
        }
      }
    }
    if (AppConfig.runtime.isDevelopment()) {
      const image = await DB.fromKey(this.storeName, data.uuid)
      fetch(`${imageStore.resource.host}/pwa/file_upload`, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: this.authHeader(`${imageStore.resource.host}/pwa/file_upload`),
        body: JSON.stringify({
          upload: {
            uuid: data.uuid,
            type: data.type,
            type_uuid: data.type_uuid,
            file_name: data.file_name,
            file_upload: image.data_url,
            survey_question_uuid: data.survey_question_uuid || null,
            survey_response_uuid: data.survey_response_uuid || null,
            customer_uuid: data.customerUuid || null,
          }
        })
      }).then(onFileUpload)
    } else {
      const body = await ImageDb.url(data.uuid)

      let structure = {
        uuid: data.uuid,
        type: data.type,
        type_id: data.type_uuid,
        file_name: data.file_name,
        authorization: data.apiKey,
        partner_code: data.partnerCode,
        createdAt: DateTime.local().toUTC().toISO(),
        survey_question_uuid: data.survey_question_uuid || null,
        survey_response_uuid: data.survey_response_uuid || null,
        image: body,
        customer_uuid: data.customerUuid || null,
      }
      fetch('https://upload.sasa.solutions/', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(structure)
      }).then(onFileUpload)
    }
  }

  static async pending() {
    const db = await openDB('workbox-background-sync')
    let cursor = await db.transaction('requests').store.openCursor()

    while (cursor) {
      cursor = await cursor.continue()
    }

    return null
  }

  static getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  static authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const { authenticationKey } = useUserStore()
    const isLoggedIn = !!authenticationKey
    let headers = {}
    headers['Accept'] = 'application/json'
    headers['Content-Type'] = 'application/json'
    const isApiUrl = url.startsWith('http://localhost') || url.startsWith('http://connect')
    if (isLoggedIn && isApiUrl) {
      headers['Authorization'] = authenticationKey
    }
    return headers
  }
}
